import React from 'react';

const BrandLogo = ({ className = "w-16 h-16" }) => {
  return (
    <img 
      src="https://media-manager-c.questera.ai/greta-media/3e35c57609be74ead6f195d4490da55d4372d3d81f2addd70da7a1c1f3837138828f509943682ca5154ffc7f755bbc6d/images/aW1hZ2UvcG5n/815a90de9ebde8a162cbfa455b1243cf.png" 
      alt="We The Billions" 
      className={`${className} object-contain`} 
    />
  );
};

export default BrandLogo;